import { tickerItems } from "@/mocks/rank";

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="border-b border-background-200 bg-foreground-950">
      <div className="flex items-center gap-3 px-4 py-2.5 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 font-label text-xs font-medium text-background-50">
          <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-background-50" />
          实时播报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-8 whitespace-nowrap">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-2 font-label text-xs text-background-100 md:text-sm">
                <i className="ri-flashlight-line text-accent-400" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}